import type { ReactNode } from "react";

import { useUniqueId } from "metabase/common/hooks/use-unique-id";
import { Switch } from "metabase/ui";

import {
  ImageContainer,
  ToggleContainer,
  ToggleRoot,
} from "./ImageToggle.styled";

export interface ImageToggleProps {
  label: string;
  value: boolean;
  children?: ReactNode;
  onChange: (value: boolean) => void;
}

export const ImageToggle = ({
  label,
  value,
  children,
  onChange,
}: ImageToggleProps): JSX.Element => {
  const toggleId = useUniqueId("image-toggle-");

  return (
    <ToggleRoot>
      <ImageContainer>{children}</ImageContainer>
      <ToggleContainer>
        <Switch
          id={toggleId}
          label={label}
          labelPosition="left"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          w="100%"
          styles={{
            body: { justifyContent: "space-between", width: "100%" },
          }}
        />
      </ToggleContainer>
    </ToggleRoot>
  );
};
